import React from 'react'
import RowPost from './Components/RowPoster/RowPost'
import { originals, action,ComedyMovies,HorrorMovies,RomanceMovies,Documentaries } from './imgUrl'
function RowImgs() {
  return (
    <div>
     <RowPost imgurl={originals} title="Netflix Originals" />
      <RowPost imgurl={action} title="Action" isSmall />
      <RowPost imgurl={ComedyMovies} title="Comedey" isSmall />
      <RowPost imgurl={HorrorMovies} title="Horror" isSmall />
      <RowPost imgurl={RomanceMovies} title="Romance" isSmall />
      <RowPost imgurl={Documentaries} title="Documentaries" isSmall />

    </div>
  )
}

export default RowImgs